export const getCurrencySymbol = (currency: string) => {
    switch (currency) {
        case "USD":
            return "$";
        case "EUR":
            return '\u20AC';
        case "BRL":
            return "R$";
        case "GBP":
            return '\u00A3';
        default:
            return '\u20AC';
    }
}
